import { getRelevantOutage } from "../../utils";
import { RootState } from "../reducers";

export const outageStatusSelector = (state: RootState) => state.outageStatus.outageStatuses;
export const outageStatusInProgressSelector = (state: RootState) => state.outageStatus.getOutageStatusInProgress;
export const lastOutageStatusFetchSelector = (state: RootState) => state.outageStatus.lastOutageStatusFetch;

export const currentPathOutageStatusSelector = (state: RootState) => {
    return getRelevantOutage(state.outageStatus.outageStatuses || [], state.user.currentPath)
}